import cx from 'classnames';
import {
  HOME_PAGE_WHY_US_SECTION_CONTENT,
  CDN_CLRSAVE_URL,
} from '../../constants/index';

const WhyUsSection = () => (
  <div className="mb20 mt30">
    <h2 className={cx('text--xxlg mb40 text-center')}>
      {HOME_PAGE_WHY_US_SECTION_CONTENT.heading}
    </h2>
    <p
      className={cx(
        'text--lg font--grey mobile-only--text--xmd mb20 text-center desktop-only'
      )}
    >
      {HOME_PAGE_WHY_US_SECTION_CONTENT.subtitle}
    </p>
    <div className={'mb20'}>
      {(HOME_PAGE_WHY_US_SECTION_CONTENT.cards || []).map(card => (
        <div
          className={cx('inline mb40 columns large-4 medium-4 small-12')}
          key={card.title}
        >
          <img
            src={`${CDN_CLRSAVE_URL}${card.image}`}
            className={cx(
              'image mt10 mb10 mr10 ml10 float--left large-1 medium-1'
            )}
            alt={card.title}
          />
          <div className="large-9 large-offset-2">
            <h5 className={cx('mt5 mb5 text--lg')}>{card.title}</h5>
            <p className={cx('text--sm font--fadedgrey')}>{card.description}</p>
          </div>
        </div>
      ))}
      <style jsx>{`
        .image {
          height: 22px;
          width: 22px;
        }
      `}</style>
    </div>
  </div>
);
export default WhyUsSection;



// WEBPACK FOOTER //
// ./components/homePage/whyUsSection.tsx